import type { Constructor, MappingDefinition, MappingRule } from './types';
import type { Mapper } from './Mapper';

export class MappingConfiguration<TSource, TDestination> {
  private definition: MappingDefinition<TSource, TDestination>;
  private mapper: Mapper;

  constructor(
    mapper: Mapper,
    sourceType: Constructor<TSource>,
    destinationType: Constructor<TDestination>
  ) {
    this.mapper = mapper;
    this.definition = {
      sourceType,
      destinationType,
      rules: [],
      autoMap: true,
    };
  }

  forMember<K extends keyof TDestination>(
    destinationKey: K,
    transform: (source: TSource) => TDestination[K]
  ): this {
    this.definition.rules.push({
      destinationKey,
      transform,
    } as MappingRule<TSource, TDestination>);
    return this;
  }

  disableAutoMap(): this {
    this.definition.autoMap = false;
    return this;
  }

  reverseMap(): MappingConfiguration<TDestination, TSource> {
    return this.mapper.createMap(
      this.definition.destinationType,
      this.definition.sourceType
    );
  }

  getDefinition(): MappingDefinition<TSource, TDestination> {
    return this.definition;
  }
}
